module.exports = __webpack_public_path__ + "img/ban_01.bb9c5b00.png";